<template>
    <v-app>
        <v-layout>
            <!-- Hauptmenü //////////////////////////////////////////////////////////////////////////////////////// -->
            <v-navigation-drawer v-model="drawer" temporary>
                <div class="d-flex justify-space-between align-center pa-3">
                    <div @click="triggerInertiaLink('user.profile.edit')"
                         :title="$t('layout.menu.edit_profile')"
                         class="cursor-pointer d-flex align-center no-decoration text-decoration-none">
                        <v-avatar :color="$page.props.auth.user.avatar_path ? '' : getColorFor($page.props.auth.user.fullName)" class="ml-0 mr-2" size="small">
                            <v-img v-if="$page.props.auth.user.avatar_path" :src="$page.props.auth.user.avatar_path" />
                            <span v-else class="text-white">{{ getInitials($page.props.auth.user.fullName) }}</span>
                        </v-avatar>
                        <span class="rc-title-card">{{ $page.props.auth.user.fullName }}</span>
                    </div>

                    <inertia-link :title="$t('layout.menu.logout')" :href="$route('logout')" method="post" as="button">
                        <v-icon size="small">mdi-logout</v-icon>
                    </inertia-link>
                </div>

                <v-divider />

                <v-list nav density="compact">
                    <v-list-item @click.prevent="triggerInertiaLink('dashboard')"
                                 :href="$route('dashboard')">
                        <v-list-item-title>{{ $t('layout.menu.dashboard') }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item v-if="$page.props.auth.user.operator"
                                 @click.prevent="triggerInertiaLink('campaigns.createDemo')"
                                 :href="$route('campaigns.createDemo')">
                        <v-list-item-title>{{ $t('layout.menu.create_demo') }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click.prevent="triggerInertiaLink('accounts.index')"
                                 :href="$route('accounts.index')">
                        <v-list-item-title>{{ $t('layout.menu.accounts') }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click.prevent="triggerInertiaLink('campaigns.index')"
                                 :href="$route('campaigns.index')">
                        <v-list-item-title>{{ $t('layout.menu.campaigns') }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item v-if="$page.props.auth.user.operator"
                                 @click.prevent="triggerInertiaLink('applications.index')"
                                 :href="$route('applications.index')">
                        <v-list-item-title>{{ $t('layout.menu.applications') }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item v-if="$page.props.auth.user.operator"
                                 @click.prevent="triggerInertiaLink('component-presets.index')"
                                 :href="$route('component-presets.index')">
                        <v-list-item-title>{{ $t('layout.menu.component_presets') }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item v-if="$page.props.auth.user.operator"
                                 @click.prevent="triggerInertiaLink('fonts.index')"
                                 :href="$route('fonts.index')">
                        <v-list-item-title>{{ $t('layout.menu.fonts') }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item v-if="$page.props.auth.user.operator"
                                 @click.prevent="triggerInertiaLink('categories.index')"
                                 :href="$route('categories.index')">
                        <v-list-item-title>{{ $t('layout.menu.categories') }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item v-if="$page.props.auth.user.operator"
                                 @click.prevent="triggerInertiaLink('seasons.index')"
                                 :href="$route('seasons.index')">
                        <v-list-item-title>{{ $t('layout.menu.seasons') }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item v-if="$page.props.auth.user.operator"
                                 @click.prevent="triggerInertiaLink('users.index')"
                                 :href="$route('users.index')">
                        <v-list-item-title>{{ $t('layout.menu.users') }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item v-if="$page.props.auth.user.operator"
                                 @click.prevent="triggerInertiaLink('platform.index')"
                                 :href="$route('platform.index')">
                        <v-list-item-title>{{ $t('layout.menu.platform') }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click.prevent="triggerInertiaLink('catalogue')"
                                 :href="$route('catalogue')">
                        <v-list-item-title>{{ $t('layout.menu.catalogue') }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item v-if="$page.props.auth.user.operator" href="/docs" target="_blank">
                        <v-list-item-title>{{ $t('layout.menu.docs') }}</v-list-item-title>
                    </v-list-item>
                </v-list>

                <template v-if="$page.props.auth.user.operator">
                    <v-divider />
                    <div class="pa-4">
                        <div class="rc-label mb-2" style="text-transform:uppercase;letter-spacing:.06em;font-weight:500">{{ $t('layout.menu.online_now') }}</div>
                        <ul style="list-style-type: none;">
                            <li v-for="(user, index) in present_users" :key="index" class="rc-meta">
                                <v-icon v-if="user.operator" size="x-small" class="mr-2 mb-1" :title="$t('layout.menu.operator')">mdi-shield-crown-outline</v-icon>
                                <inertia-link :href="$route('users.edit', user)" :title="user.email" class="no-decoration" :class="{'non-operator': !user.operator}">
                                    {{ user.fullName }}
                                </inertia-link>
                            </li>
                        </ul>
                    </div>
                </template>
            </v-navigation-drawer>

            <v-main>
                <!-- Systemleiste ///////////////////////////////////////////////////////////////////////////////// -->
                <div class="rc-systembar">
                    <span>REDCODE.DE Campaigns</span><!-- i18n-ignore: Marke -->
                    <span class="rc-systembar__sep">|</span>
                    <span>{{ $page.props.auth.user.fullName }}</span>
                    <span class="rc-spacer"></span>
                    <language-switch />
                </div>

                <!-- Kundensicht: Hinweisbalken, solange sie läuft /////////////////////////////////////////////// -->
                <!--
                    Steht bewusst ganz oben und in Warnfarbe: Wer vergisst,
                    dass er in der Kundensicht ist, wundert sich über fehlende
                    Menüpunkte und hält sie für einen Fehler.
                -->
                <div v-if="customerView.active" class="rc-customerbar">
                    <div class="rc-customerbar__inner">
                        <v-icon size="17">mdi-eye-outline</v-icon>
                        <span class="rc-customerbar__text">
                            {{ $t('layout.customer_view.active') }} <strong>{{ customerView.account?.name }}</strong>.<!--
                            --><span class="rc-customerbar__hint">
                                {{ $t('layout.customer_view.hint') }}
                            </span>
                        </span>
                        <button type="button"
                                class="rc-customerbar__stop"
                                @click="stopCustomerView">
                            {{ $t('layout.customer_view.stop') }}
                        </button>
                    </div>
                </div>

                <!-- Topbar mit Menüknopf, Seitentitel und Tableiste /////////////////////////////////////////////// -->
                <header id="header_toolbar" class="rc-topbar">
                    <div class="rc-topbar__inner" :class="{'rc-topbar__inner--no-tabs': !tabs.length}">
                        <button type="button"
                                class="rc-menu-btn"
                                :title="$t('layout.menu.open')"
                                :aria-label="$t('layout.menu.open')"
                                @click.stop="drawer = !drawer">
                            <v-icon size="20">mdi-menu</v-icon>
                        </button>

                        <div class="rc-topbar__title">{{ page_title }}</div>

                        <div class="rc-spacer"></div>

                        <!--
                            Nur für echte Operatoren und nur, wenn die offene
                            Seite sich überhaupt auf einen Kunden bezieht.
                        -->
                        <button v-if="canStartCustomerView"
                                type="button"
                                class="rc-btn-ghost rc-topbar__customer"
                                :title="$t('layout.customer_view.start_title', {account: customerView.available.name})"
                                @click="startCustomerView">
                            <v-icon size="17">mdi-eye-outline</v-icon>
                            <span class="rc-topbar__customer-label">{{ $t('layout.customer_view.start') }}</span>
                        </button>

                        <div v-if="currentPage_presentUsers.present_users" class="avatars-group stacked">
                            <profile-avatar v-for="currPageUser in currentPage_presentUsers.present_users"
                                            :key="currPageUser.id"
                                            :user="currPageUser" />
                        </div>
                    </div>

                    <!--
                        Kampagnen-Tabs. Bewusst schlichte Knöpfe statt v-tabs:
                        Das Design kennt nur Textfarbe und einen Unterstrich,
                        und die alte Reiter-Optik brauchte dafür ein halbes
                        Dutzend Pseudoelemente.
                    -->
                    <nav v-if="tabs.length" class="rc-tabs" :aria-label="tabsLabel">
                        <button v-for="tab in tabs"
                                :key="tab.route"
                                type="button"
                                class="rc-tab"
                                :class="{'rc-tab--active': isActiveTab(tab)}"
                                :aria-current="isActiveTab(tab) ? 'page' : null"
                                @click="triggerInertiaVisit(tab.route, tab.params ?? {})">
                            {{ tab.label }}
                        </button>
                    </nav>
                </header>

                <v-alert v-model="showSuccessMessage" type="success" closable
                         ref="success_alert"
                         style="position:absolute;z-index:10000;top:2em;right:2em;">
                    {{ success_message }}
                </v-alert>
                <v-alert v-model="showErrorMessage" type="error" closable
                         ref="error_alert"
                         style="position:absolute;z-index:10000;top:2em;right:2em;">
                    {{ error_message }}
                </v-alert>

                <!-- Inhaltsspalte //////////////////////////////////////////////////////////////////////////////// -->
                <div class="rc-page">
                    <slot></slot>
                </div>

                <!-- Support-Footer /////////////////////////////////////////////////////////////////////////////// -->
                <footer class="rc-footer">
                    <div class="rc-footer__head">{{ $t('layout.footer.support') }}</div>
                    <div class="rc-footer__links">
                        <a href="mailto:service@redcode.org?subject=REDCDODE.DE-Specials-Support" target="_blank">{{ $t('layout.footer.email') }}</a>
                        <a href="tel:+494040188751" target="_blank">{{ $t('layout.footer.phone') }}</a>
                        <a href="https://wa.me/494040188751?text=Adventskalender-Support" target="_blank">{{ $t('layout.footer.whatsapp') }}</a>
                        <a href="https://redcodede.slack.com/archives/C01D6N1LQ59" target="_blank">{{ $t('layout.footer.slack') }}</a>
                        <a href="https://www.redcode.de/#contact" target="_blank">{{ $t('layout.footer.form') }}</a>
                    </div>

                    <div class="rc-footer__brand">HAPPYMO.RE ★ ADMIN PANEL 2.0</div><!-- i18n-ignore: Marke -->
                    <div>{{ $t('layout.footer.powered_by') }} <a href="https://www.redcode.de/" target="_blank">REDCODE.DE</a></div><!-- i18n-ignore: Marke -->

                    <div class="rc-footer__links" style="margin-top:12px">
                        <inertia-link :href="$route('impressum')" target="_blank" rel="nofollow noindex">{{ $t('layout.footer.imprint') }}</inertia-link>
                        <inertia-link :href="$route('datenschutz')" target="_blank" rel="nofollow noindex">{{ $t('layout.footer.privacy') }}</inertia-link>
                    </div>
                </footer>
            </v-main>
        </v-layout>

        <v-dialog v-model="show_global_message_dialog" width="100%" max-width="480" persistent>
            <v-card>
                <v-card-title v-html="global_message.title"></v-card-title>
                <v-card-text v-html="global_message.message"></v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="show_global_message_dialog = false">{{ $t('common.actions.ok') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script setup>
import {ref, computed, onMounted, onUnmounted, watch} from "vue";
import {getInitials, getColorFor} from "../utils/helpers";
import {usePage} from "@inertiajs/inertia-vue3";
import {triggerInertiaVisit} from "../utils/inertiaHelpers";
import ProfileAvatar from "../components/ProfileAvatar";
import LanguageSwitch from "../components/LanguageSwitch.vue";
import {useI18n} from "../i18n";
import {useGlobalPresenceChannel} from "../utils/globalPresenceChannel";
import {usePresenceStore} from "../Stores/PresenceStore";
import echoInstance from "../services/echo";

const drawer = ref(false);
const {t} = useI18n();
const attrs = usePage().props.value;
const currentPage_presentUsers = usePresenceStore();

// ----------------------------------------------------------------------------
// Global Presence Channel
// ----------------------------------------------------------------------------
const {present_users} = useGlobalPresenceChannel();

setTimeout(() => {
    present_users.value.forEach((user) => {
        if (user) {
            if (user.operator == 0) document.querySelector("#header_toolbar button").classList.add("non-operator-online");
        }
    });
}, 2000);


// ----------------------------------------------------------------------------
// Tabs
// ----------------------------------------------------------------------------
const current_route = computed(() => {
    return usePage().props.value.current_route;
});

/*
 * Jeder Tab bringt seine eigenen Routenparameter mit. Vorher stand die
 * Kampagnen-ID fest in der Nav -- damit liess sich keine zweite Tab-Gruppe
 * anhängen, die keine braucht.
 */
const campaignTabs = computed(() => {
    const campaign = usePage().props.value.campaign;

    if (!campaign) return [];

    const params = {campaign: campaign.id};

    const tabs = [
        {route: 'campaigns.show',     label: t('layout.tabs.start'),    params},
        {route: 'campaigns.schedule', label: t('layout.tabs.schedule'), params},
        {route: 'campaigns.publish',  label: t('layout.tabs.publish'),  params},
    ];

    if (usePage().props.value.auth.user.operator) {
        tabs.push({route: 'campaigns.campaignSettings', label: t('layout.tabs.settings'), params});
        // Farben und Schrift der Kampagne. Vorerst nur für Operatoren,
        // wie die anderen gestalterischen Eingriffe auch.
        tabs.push({route: 'campaigns.styling',          label: t('layout.tabs.styling'),  params});

        /*
         * Gewinnspiel -- nur wenn die Kampagne es überhaupt führt.
         *
         * Der Tab zeigt auf die *Kampagne*, nicht auf das Gewinnspiel: So
         * trägt er dieselben Parameter wie alle anderen und muss nicht
         * wissen, ob schon eines existiert. Die Entscheidung "bearbeiten
         * oder anlegen" fällt im Controller.
         *
         * Vorher war das Gewinnspiel nur über den "+"-Knopf in der
         * Kampagnenliste erreichbar -- aus der Kampagne selbst führte kein
         * Weg dorthin.
         *
         * @see App\Http\Controllers\RaffleController::forCampaign()
         */
        if (campaign.raffle) {
            tabs.push({
                route: 'campaigns.raffle',
                label: t('layout.tabs.raffle'),
                params,
                /*
                 * `also`: Der "+"-Knopf in der Kampagnenliste führt weiter
                 * direkt auf raffles.edit/raffles.create. Ohne diese Angabe
                 * stünde die Leiste dort ohne hervorgehobenen Tab -- man
                 * wäre auf einer Kampagnenseite, ohne zu sehen, auf welcher.
                 */
                also: ['raffles.edit', 'raffles.create'],
            });
        }

        tabs.push({route: 'campaigns.operatorSettings', label: t('layout.tabs.operator'), params});
    }

    return tabs;
});

const platformTabs = computed(() => [
    {route: 'platform.index', label: t('layout.tabs.config')},
    {route: 'platform.stats', label: t('layout.tabs.stats')},
]);

const CAMPAIGN_TAB_ROUTES = [
    'campaigns.show', 'campaigns.schedule', 'campaigns.publish',
    'campaigns.operatorSettings', 'campaigns.campaignSettings', 'campaigns.styling',
    /*
     * Das Gewinnspiel gehört zur Kampagne, also bleibt die Leiste dort
     * stehen. `raffles.edit` und `raffles.create` sind mit aufgeführt, weil
     * der "+"-Knopf in der Kampagnenliste weiter direkt dorthin führt -- über
     * beide Wege soll dieselbe Leiste erscheinen.
     */
    'campaigns.raffle', 'raffles.edit', 'raffles.create',
];

const PLATFORM_TAB_ROUTES = ['platform.index', 'platform.stats'];

/* Welche Tab-Gruppe zur aktuellen Seite gehört -- oder keine. */
const tabs = computed(() => {
    if (CAMPAIGN_TAB_ROUTES.includes(current_route.value)) return campaignTabs.value;
    if (PLATFORM_TAB_ROUTES.includes(current_route.value)) return platformTabs.value;

    return [];
});

/*
 * Welcher Tab hervorgehoben wird.
 *
 * In der Regel die eigene Route. Ein Tab kann über `also` weitere nennen, die
 * zu ihm gehören -- dieselbe Seite ist teils über mehrere Routen erreichbar.
 */
const isActiveTab = (tab) => {
    if (current_route.value === tab.route) return true;

    return (tab.also ?? []).includes(current_route.value);
};

const tabsLabel = computed(() => {
    return PLATFORM_TAB_ROUTES.includes(current_route.value) ? t('layout.tabs.platform_areas') : t('layout.tabs.campaign_areas');
});

// ----------------------------------------------------------------------------
// Kundensicht
//
// Zustand und Bezug kommen aus HandleInertiaRequests, damit jede Seite sie
// hat, ohne dass ein Controller sie einzeln mitgeben muss.
// ----------------------------------------------------------------------------
const customerView = computed(() => {
    return usePage().props.value.customer_view ?? {};
});

const canStartCustomerView = computed(() => {
    const v = customerView.value;
    return Boolean(v.can_switch && v.available && ! v.active);
});

function startCustomerView() {
    const v = customerView.value;
    if ( ! v.available) return;

    // Die Kampagne wird mitgegeben, damit der Wechsel auf ihrer Startseite
    // landet statt auf der Kontoübersicht. Der Controller prüft, ob sie
    // wirklich zu diesem Account gehört.
    triggerInertiaVisit('customer-view.start', {account: v.available.id}, {
        method: 'post',
        data: {campaign_id: v.campaign_id ?? null},
    });
}

function stopCustomerView() {
    triggerInertiaVisit('customer-view.stop', {}, {method: 'delete'});
}

// ----------------------------------------------------------------------------
// Page Title
// ----------------------------------------------------------------------------
const page_title = computed(() => {
    return usePage().props.value.page_title;
});
watch(page_title, () => {
    document.title = page_title.value + ' | REDCODE.DE CAMPAIGNS';
});

// ----------------------------------------------------------------------------
// Session Flash Messages
// ----------------------------------------------------------------------------
const showSuccessMessage = ref(false);
const showErrorMessage = ref(false);
const success_message = computed(() => {
    showSuccessMessage.value = !!usePage().props.value.flash.success;
    return usePage().props.value.flash.success;
});
const error_message = computed(() => {
    showErrorMessage.value = !!usePage().props.value.flash.error;
    return usePage().props.value.flash.error;
});

watch(success_message, () => {
    window.setTimeout(() => {
        showSuccessMessage.value = false;
        showErrorMessage.value = false;
    }, 1500);
});

// ----------------------------------------------------------------------------
// Helper Functions
// ----------------------------------------------------------------------------
function triggerInertiaLink(routeName) {
    drawer.value = false;
    triggerInertiaVisit(routeName);
}


const global_message = ref(null);
const show_global_message_dialog = ref(false);
function onGlobalMessageReceived(event) {
    console.log("onGlobalMessageReceived", event);
    global_message.value = event;
    show_global_message_dialog.value = true;
}

// ----------------------------------------------------------------------------
// on Mounted Hook
// ----------------------------------------------------------------------------
onMounted(() => {
    document.title = usePage().props.value.page_title + ' | REDCODE.DE CAMPAIGNS';
    echoInstance.join('global.presence').listen('GlobalMessageSend', onGlobalMessageReceived);
});
onUnmounted(() => {
    echoInstance.join('global.presence')
        .stopListening('GlobalMessageSend', onGlobalMessageReceived);
    echoInstance.leave('global.presence');
});
</script>

<style lang="scss">
// Grüner Punkt an Nutzern, die keine Operatoren sind: zeigt an, dass
// gerade jemand von Kundenseite mitschaut.
.non-operator {
    position: relative;

    &::after {
        content: "";
        display: block;
        width: .5rem; height: .5rem;
        border-radius: 50%;
        background: #3dffa7;
        position: absolute;
        inset: 60% -8px auto auto;
        box-shadow: 0 0 0 2px rgba(255,255,255,.8);
    }
}
.non-operator-online {
    position: relative;

    &::before {
        content: "";
        display: block;
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 50%;
        background: #3dffa7;
        position: absolute;
        inset: 55% auto auto 60%;
        box-shadow: 0 0 0 2px #EFF3F8;
        z-index: 5;
    }
}
</style>
